<template>
    <div
     :class="hasBg ? 'cnd-button checked' : 'cnd-button unchecked'"
     :style="innerstyle"
      @click="$emit('btnclick')"
     >
        <img :style="BtnText ? 'margin-right: 4px;': ''" v-if="imgPath" :src="imgPath" />
        <span v-if="BtnText">{{BtnText}}</span>
    </div>
</template>

<script>
export default {
  props: {
    hasBg: {
      type: Boolean,
      default: false,
    },
    imgPath: String,
    BtnText: String,
    innerstyle: String,
  },
};
</script>

<style lang="scss" scoped>
  .cnd-button {
    display: flex;
    align-items: center;
    padding: 4px 6px;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }
  .checked {
    background: #D9E4FF;
    color: #1E5EFF;
  }
  .unchecked {
    color: #5A607F;
    background: #FFFFFF;
    border: 1px solid #D7DBEC;
  }
</style>
